module.exports = __webpack_public_path__ + "img/daviplata.63b3f2e1.png";